import { render, staticRenderFns } from "./VirtualKeyboardHatsu.vue?vue&type=template&id=4c28b178&scoped=true&"
import script from "./VirtualKeyboardHatsu.vue?vue&type=script&lang=js&"
export * from "./VirtualKeyboardHatsu.vue?vue&type=script&lang=js&"
import style0 from "./VirtualKeyboardHatsu.vue?vue&type=style&index=0&id=4c28b178&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c28b178",
  null
  
)

export default component.exports